import React from "react";
import styles from "./Loading.module.css";

const Loading = ({ 
  tip = "Đang tải dữ liệu...", 
  size = "large",
  className = "",
  fullScreen = true 
}) => {
  const loadingClass = `${styles.loadingContainer} ${className} ${fullScreen ? styles.fullScreen : ''}`;
  const spinnerSize = size === "small" ? styles.spinnerSmall : size === "large" ? styles.spinnerLarge : styles.spinnerMedium;

  return (
    <div className={loadingClass}>
      <div className={styles.loadingContent}>
        <div className={`${styles.customSpinner} ${spinnerSize}`}>
          <div className={styles.spinnerDot}></div>
          <div className={styles.spinnerDot}></div>
          <div className={styles.spinnerDot}></div>
          <div className={styles.spinnerDot}></div>
        </div>
        {tip && <div className={styles.loadingText}>{tip}</div>}
      </div>
    </div>
  );
};

export default Loading;
